import { Outlet, useNavigate } from "react-router-dom";
import { ClerkProvider, SignIn, SignedIn, SignedOut, UserButton, useUser } from "@clerk/clerk-react";
import { Image } from "@fluentui/react-components";
import { useEffect } from "react";
import { GetExistingCitations } from "./citation/get-existing-citations";
import { QueryClient, QueryClientConfig, QueryClientProvider } from "@tanstack/react-query";
import { clerkPublishableKey, environment } from "../utils/constants";
import { isRunningInBrowser } from "./App";

const url = window.location.href;

const options: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
      gcTime: 1000 * 60 * 60 * 2,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
};

const queryClient = new QueryClient(options);

export const successMessage = "User is signed in";

const HeaderContainer = () => {
  const navigate = useNavigate();

  const { isSignedIn } = useUser();

  useEffect(() => {
    if (isSignedIn) {
      if (url.includes("isDialog")) {
        Office.context.ui.messageParent(successMessage);
      }
    }
  }, [isSignedIn]);

  return (
    <div className="flex flex-row items-center justify-between w-full p-2">
      <div>
        <Image width="90" height="100" src={"assets/midpage-transparent-cropped.png"} alt={"midpage"} />
      </div>
      <SignedIn>
        <div className="flex flex-row items-center gap-1">
          <GetExistingCitations />
          <UserButton afterSignOutUrl="/taskpane.html" />
        </div>
      </SignedIn>
      {!url.includes("isDialog") && !isRunningInBrowser() && (
        <SignedOut>
          <button
            onClick={() => {
              Office.context.ui.displayDialogAsync(
                `${origin}/taskpane.html?login=true`,
                { width: 50, height: 50 },
                (result) => {
                  const dialog = result.value;
                  dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
                    if (typeof arg === "object" && arg.hasOwnProperty("message")) {
                      const argAsObject = arg as { message: string };
                      const messageFromDialog = argAsObject.message;
                      if (messageFromDialog === successMessage) {
                        dialog.close();
                        navigate(0);
                      }
                    }
                  });
                  if (result.status !== Office.AsyncResultStatus.Succeeded) {
                    console.log("Error", result.error);
                  }
                }
              );
            }}
            className="px-3 py-1 text-white rounded-md bg-neutral-800"
          >
            Log in
          </button>
        </SignedOut>
      )}
      {isRunningInBrowser() && <GetExistingCitations />}
    </div>
  );
};

export const RootLayout = () => {
  return (
    <ClerkProvider publishableKey={clerkPublishableKey[environment]}>
      <QueryClientProvider client={queryClient}>
        <div className="h-full">
          <HeaderContainer />
          {!url.includes("isDialog") ? (
            <Outlet />
          ) : (
            <SignedOut>
              <div className="flex flex-col items-center self-center w-full h-full align-middle">
                <SignIn afterSignInUrl={`${origin}/taskpane.html?isDialog=true`} />
              </div>
            </SignedOut>
          )}
        </div>
      </QueryClientProvider>
    </ClerkProvider>
  );
};
